import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="cookie-detection"
export default class extends Controller {
  static identifier = "cookie-detection"
  static targets = ["alert"]

  connect() {
    this.checkThirdPartyCookies()
  }

  checkThirdPartyCookies() {
    // Only check if we're on HTTPS (required for secure cookies)
    if (window.location.protocol !== 'https:' && 
        window.location.hostname !== 'localhost' && 
        !window.location.hostname.startsWith('127.0.0.1')) {
      return
    }

    try {
      // Try to set a test cookie with sameSite: 'none' and secure: true
      const testCookieName = 'deepco_cookie_test_' + Date.now()
      const testCookieValue = 'test'
      document.cookie = `${testCookieName}=${testCookieValue}; SameSite=None; Secure; path=/; max-age=60`

      // Try to read it back immediately
      const cookies = document.cookie.split(';')
      const found = cookies.some(cookie => {
        const [name] = cookie.trim().split('=')
        return name === testCookieName
      })

      // Clean up test cookie
      document.cookie = `${testCookieName}=; SameSite=None; Secure; path=/; max-age=0`

      // If cookie wasn't found, third-party cookies are blocked
      if (!found && this.hasAlertTarget) {
        this.alertTarget.classList.remove('hidden')
      }
    } catch (e) {
      // If we can't set cookies at all, they're likely blocked
      if (this.hasAlertTarget) {
        this.alertTarget.classList.remove('hidden')
      }
    }
  }
}
